import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {CIPHER_FEE, PRICE_PER_PUBLICATION} from "../../utils/globals";
import { KazButtonComponent } from '../kaz-button/kaz-button.component';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'kaz-ad-info',
    templateUrl: './kaz-ad-info.component.html',
    styleUrls: ['./kaz-ad-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazButtonComponent, CurrencyPipe]
})
export class KazAdInfoComponent {
  protected readonly CIPHER_FEE = CIPHER_FEE;
  protected readonly PRICE_PER_PUBLICATION = PRICE_PER_PUBLICATION;
  showAdInfo: boolean = true;
  @Output() closeInfoOnEmit = new EventEmitter();

  closeAdInfo() {
    this.showAdInfo = false;
    this.closeInfoOnEmit.emit();
  }
}
